<template>
    <div style="margin-top: -15px">
      <el-row style="margin-top: -15px" v-if="row.pid !== ''">
        <el-col :span="12" style="text-align: right">服务对象：</el-col>
        <el-col :span="12">
          <span> {{row.person_name}} </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px" v-if="row.pid !== ''">
        <el-col :span="12" style="text-align: right">性别：</el-col>
        <el-col :span="12">
          <span> {{getSex(row.person_sex)}} </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px" v-if="row.pid !== ''">
        <el-col :span="12" style="text-align: right">年龄：</el-col>
        <el-col :span="12"> <span> {{getAgeDesc(row.birthday)}} </span>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="5" style="text-align: right;margin-top: 15px">
          <span style="color: red">*</span>服务时间：
        </el-col>
        <el-col :span="19" style="margin-top: 15px">
          <el-date-picker v-fixZoom style="width: 100%" v-model="svs_tm" value-format="yyyy-MM-dd HH:mm:ss"
                          type="datetime" placeholder="选择日期时间" default-time="10:00:00"></el-date-picker>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px">
        <el-col :span="5" style="text-align: right">
          <span style="color: red">*</span>备注：
        </el-col>
        <el-col :span="19">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入处理备注"
            v-model="remark">
          </el-input>
        </el-col>
      </el-row>
      <div style="margin-top: 20px;text-align: center">
<!--        <el-button type="danger" round @click="handleCommit(2)">拒接</el-button>-->
<!--        <el-button type="primary" round @click="handleCommit(1)">接受</el-button>-->
        <div class="cancel-btn" @click="handleCommit()">
          <span>结束服务单</span>
        </div>
      </div>
    </div>
</template>

<script>
import {createpersonsupplierservicerecords} from '../../../api/companyorder'
import {sendSub} from '../../../mq'
import {deletepersonsupplierservice} from '../../../api/serviceMark'

export default {
  name: 'orderHandle',
  model: {
    prop: 'handleOrderShow',
    event: 'change'
  },
  props: {
    handleOrderRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: '',
      svs_tm: '',
      remark: ''
    }
  },
  created () {
    console.log(this.handleOrderRow)
    this.row = this.handleOrderRow.row
  },
  methods: {
    handleCommit (type) {
      if (this.svs_tm === '') {
        this.$message.error('请选择服务时间')
        return
      }
      if (this.remark === '') {
        this.$message.error('请输入事件处理备注')
        return
      }
      let data = {
        id: 0,
        pid: this.row.pid,
        pss_id: this.row.pss_id,
        remark: this.remark,
        svs_tm: this.svs_tm,
        sys_person_id: this.$store.state.user.syspersonid,
        supplier_org_id: this.row.supplier_org_id,
        supplier_person_id: this.$store.state.user.LoginResp.supplierpersonid
      }
      let mqtts = this.$store.state.user.mqtts
      createpersonsupplierservicerecords(data).then(res => {
        this.delService()
        let dohandle = {id: this.row.id}
        sendSub('/handledoneorder' + mqtts[0], JSON.stringify(dohandle))
        this.$emit('change', false)
      }).catch(() => {})
    },
    delService () {
      let data = {
        id: this.row.id
      }
      deletepersonsupplierservice(data).then(res => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
        this.$emit('changeUpadte')
        this.$emit('change', false)
      }).catch(() => {})
    },
    back () {
      let mqtts = this.$store.state.user.mqtts
      let dohandle = {id: this.row.id}
      sendSub('/handledoneorder' + mqtts[0], JSON.stringify(dohandle))
      this.$emit('change', false)
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getAgeDesc (birthday) {
      let result = '--'
      let age = this.util.getAgeByBirth(birthday)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/handlealarm/childComponents/orderHandle.vue